export const REALDB_CONSTANT = {
  Sellersdata: "/tritya2024/Sellersdata",
  SellerBaseData: "/tritya2024/SellerBaseData",
};
